import { http } from '../../config/axios'

const postUserValidarDuploFator = (codigo: string): Promise<string> => {
  return http
    .post('api/user/validar-duplo-fator', { codigo })
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro postUserValidarDuploFator', error)
      throw Error(error.response?.data)
    })
}

export default postUserValidarDuploFator
